import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { IceMultimediaCanvas } from '../../components/icemultimedia/IceMultimediaCanvas';
import { IceMultimediaPage, multimediaModes } from '../../components/icemultimedia/IceMultimediaPage';
import { IceMultimediaStroke, IcePoint, IceRect } from '../../components/icemultimedia/IceMultimediaStroke';
import { IceMultimediaText } from '../../components/icemultimedia/IceMultimediaText';
import { Iceutility } from '../iceutility';

@Injectable({
  providedIn: 'root'
})
export class IceMultimediaService {

  pages: IceMultimediaPage[] = [];
  multimediaDataSub: Subject<string> = new Subject<string>();

  constructor() { }

  newPage(): IceMultimediaPage {
    let page = null;

    try {
      page = new IceMultimediaPage();
      this.pages.push(page);
    }
    catch (e) { // todo
    }
    return page;
  }

  deserialize(grfData: string): IceMultimediaPage[] {
    let multimediaPages: IceMultimediaPage[] = [],
      multimediaStroke: IceMultimediaStroke,
      multimediaPage: IceMultimediaPage;

    try {
      if (!Iceutility.isStringUndefinedNullOrEmpty(grfData)) {
        let items = grfData.split("%;"),
          header = items[0],
          pageData = items[1];
        let pages = pageData.split("#;");

        for (let iPg = 0; iPg < pages.length; iPg++) {
          let page = pages[iPg];

          if (!Iceutility.isdefined(page) || page == "") {
            continue;
          }

          let strokes = page.split(";");
          multimediaPage = new IceMultimediaPage();

          // Draw strokes
          for (let iStroke = 0; iStroke < strokes.length; iStroke++) {
            let stroke = strokes[iStroke];

            if (stroke.indexOf("[") == -1) {
              continue;
            }

            let strokeSeries = stroke.replace("[", "").replace("]", ""),
              strokes_arr = strokeSeries.split("|");

            if (strokeSeries == "")
              continue;

            for (let jStroke = 0; jStroke < strokes_arr.length; jStroke++) {
              let coords = strokes_arr[jStroke].split(","),
                xPos = coords[0],
                yPos = coords[1];

              if (jStroke === 0) {
                multimediaStroke = new IceMultimediaStroke(null, new IcePoint(+xPos, +yPos));
              } else {
                multimediaStroke.pointArray.push(new IcePoint(+xPos, +yPos));
              }
            }

            multimediaPage.strokeList.push(multimediaStroke);
          }

          multimediaPages.push(multimediaPage);
        }

        // Draw texts
        let textData = grfData.split("^;");

        for (let iText = 0; iText < textData.length; iText++) {
          let objText = textData[iText];
          if (objText == "")
            continue;

          let parts = objText.split("|"),
            textCoords = parts[0] || "0,0,0,0",
            pageNumber = parseInt(parts[1]),
            text = parts[2] || "";

          var coords_arr = textCoords.split(",");
          if (coords_arr.length == 4) {
            let x = parseInt(coords_arr[0]) - parseInt(coords_arr[1]),
              y = parseInt(coords_arr[2]) - parseInt(coords_arr[3]),
              page = Iceutility.isdefined(multimediaPages[pageNumber]) ? multimediaPages[pageNumber] :
                new IceMultimediaPage();

            page.textList.push(new IceMultimediaText(null, new IcePoint(x, y), text));
          }
        }
      }
    } catch (e) {

    }
    return multimediaPages;
  }

  draw(cnvs: IceMultimediaCanvas, pages: IceMultimediaPage[], rect: IceRect, clientOffsetOverideClientArea: boolean): IcePoint {
    let pt = new IcePoint(0, 0);

    for (let iPage = 0; iPage < pages.length; iPage++) {
      let pg = pages[iPage];
      pt = pg.draw(cnvs, clientOffsetOverideClientArea ? rect.left : 0, clientOffsetOverideClientArea ? rect.top: 0);
    }
    return pt;
  }

  serialize(pages: IceMultimediaPage[]): string {
    let multimediaData = "";

    for (let iPage = 0; iPage < pages.length; iPage++) {
      let page = pages[iPage];

      if (page.strokeList.length > 0) multimediaData = multimediaData + "[";
      for (let iStroke = 0; iStroke < page.strokeList.length; iStroke++) {
        let ptArray = page.strokeList[iStroke].pointArray;

        for (let iPoint = 0; iPoint < ptArray.length; iPoint++) {
          let x_coordinate = ptArray[iPoint].x,
            y_coordinate = ptArray[iPoint].y;

          if (Iceutility.isdefined(x_coordinate) && Iceutility.isdefined(y_coordinate)) {
            if (iPoint > 0) {
              if (ptArray[iPoint - 1].x == x_coordinate && ptArray[iPoint - 1].y == y_coordinate)
                continue;
            }

            multimediaData = multimediaData + x_coordinate + "," + y_coordinate + "|";
          }
        }

        multimediaData = multimediaData.slice(0, -1);
        multimediaData = multimediaData + "];[";
      }

      if (multimediaData.slice(-2) === ";[") {
        multimediaData = multimediaData.substring(0, multimediaData.length - 2);
      }

      // Text
      for (let itext = 0; itext < page.textList.length; itext++) {
        let objtext = page.textList[itext];
        multimediaData = multimediaData + "^;";

        if (Iceutility.isdefined(objtext.point.x) && Iceutility.isdefined(objtext.point.y)) {
          multimediaData = multimediaData + (objtext.point.x + ",0," + objtext.point.y + ",0|" + iPage.toString() + "|" + objtext.data);
        }
      }

      multimediaData = multimediaData + "#;";
    }

    return multimediaData;
  }

  /*
serialize()
deserialize():
getPageData(…)
getPages(…)
newStroke(Page): Icegr…Stroke
newText(Page): Icegr…Text
newData(Page): Icegr…Data

drawBackground(Canvas)
drawBitmaps(Canvas)
  */
}
